export const statesBR = [
  { uf: 'AC', region: 'norte' },
  { uf: 'AL', region: 'nordeste' },
  { uf: 'AP', region: 'norte' },
  { uf: 'AM', region: 'norte' },
  { uf: 'BA', region: 'nordeste' },
  { uf: 'CE', region: 'nordeste' },
  { uf: 'DF', region: 'centro-oeste' },
  { uf: 'ES', region: 'sudeste' },
  { uf: 'GO', region: 'centro-oeste' },
  { uf: 'MA', region: 'nordeste' },
  { uf: 'MT', region: 'centro-oeste' },
  { uf: 'MS', region: 'centro-oeste' },
  { uf: 'MG', region: 'sudeste' },
  { uf: 'PA', region: 'norte' },
  { uf: 'PB', region: 'nordeste' },
  { uf: 'PR', region: 'sul' },
  { uf: 'PE', region: 'nordeste' },
  { uf: 'PI', region: 'nordeste' },
  { uf: 'RJ', region: 'sudeste' },
  { uf: 'RN', region: 'nordeste' },
  { uf: 'RS', region: 'sul' },
  { uf: 'RO', region: 'norte' },
  { uf: 'RR', region: 'norte' },
  { uf: 'SC', region: 'sul' },
  { uf: 'SP', region: 'sudeste' },
  { uf: 'SE', region: 'nordeste' },
  { uf: 'TO', region: 'norte' }
]
